'use client';

import React, { MouseEvent } from 'react';
import { createPortal } from 'react-dom';
import { CookieSettingsDialog } from './CookieSettingsDialog';
import { ConsentStatus, TranslateFn } from '../types';

interface CookieSettingsOverlayProps {
    t: TranslateFn;
    consentStatus: ConsentStatus;
    onClose: () => void;
    onSave: (enableAnalytics: boolean) => void;
}

export function CookieSettingsOverlay({
    t,
    consentStatus,
    onClose,
    onSave,
}: CookieSettingsOverlayProps) {
    if (typeof document === 'undefined') {
        return null;
    }

    const handleOverlayClick = (event: MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return createPortal(
        <div
            className="fixed inset-0 z-[10000] flex items-center justify-center overflow-y-auto p-4 text-base"
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                WebkitBackdropFilter: 'blur(5.5px)',
                backdropFilter: 'blur(5.5px)',
            }}
            onClick={handleOverlayClick}
            data-testid="cookie-settings-overlay"
        >
            <CookieSettingsDialog
                t={t}
                onClose={onClose}
                onSave={onSave}
                consentStatus={consentStatus}
            />
        </div>,
        document.body,
    );
}
